module.exports = __webpack_public_path__ + "static/media/doa.9e0cec7f.jpg";